import React, { useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
export function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  return <header className="sticky top-0 z-50 bg-white/95 backdrop-blur-sm border-b border-gray-100 shadow-sm" data-id="element-254">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center" data-id="element-255">
        <div className="flex flex-col items-center" data-id="element-256">
          <div className="flex items-center" data-id="element-257">
            <span className="text-2xl sm:text-3xl font-bold text-slate-800 tracking-tight lowercase leading-none" data-id="element-258">
              swedenmark
            </span>
            <div className="w-1.5 h-1.5 sm:w-2 sm:h-2 rounded-full bg-gradient-to-r from-blue-500 to-purple-500 mx-0.5 translate-y-[22%]" data-id="element-259"></div>
            <span className="text-2xl sm:text-3xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-blue-500 to-purple-500 lowercase leading-none" data-id="element-260">
              ai
            </span>
          </div>
          <span className="text-[10px] sm:text-xs text-gray-500 font-medium tracking-wide hidden sm:block" data-id="element-261">
            Catch the business slipping through the cracks.
          </span>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-8" data-id="element-262">
          <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors font-medium" data-id="element-263">
            About
          </a>
          <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors font-medium" data-id="element-264">
            Services
          </a>
          <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors font-medium" data-id="element-265">
            Contact
          </a>
          <a href="#contact" className="bg-blue-600 text-white px-5 py-2.5 rounded-lg text-sm font-semibold hover:bg-blue-700 transition-colors shadow-sm" data-id="element-266">
            Get a free audit
          </a>
        </nav>

        {/* Mobile Menu Button */}
        <button className="md:hidden text-gray-600 p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} aria-label="Toggle menu" data-id="element-267">
          {isMenuOpen ? <XIcon size={24} data-id="element-268" /> : <MenuIcon size={24} data-id="element-269" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isMenuOpen && <div className="md:hidden bg-white border-t border-gray-100 py-4 absolute w-full shadow-lg" data-id="element-270">
          <div className="container mx-auto px-4 flex flex-col space-y-4" data-id="element-271">
            <a href="#about" className="text-gray-600 hover:text-blue-600 transition-colors py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-272">
              About
            </a>
            <a href="#services" className="text-gray-600 hover:text-blue-600 transition-colors py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-273">
              Services
            </a>
            <a href="#contact" className="text-gray-600 hover:text-blue-600 transition-colors py-2 font-medium" onClick={() => setIsMenuOpen(false)} data-id="element-274">
              Contact
            </a>
            <a href="#contact" className="bg-blue-600 text-white px-4 py-3 rounded-lg text-center font-semibold hover:bg-blue-700 transition-colors" onClick={() => setIsMenuOpen(false)} data-id="element-275">
              Get a free audit
            </a>
          </div>
        </div>}
    </header>;
}